import { useMemo, useState } from "react"

import Spinner from "@/components/common/spinner/spinner"
import LoadingContext from "@/hooks/loadingContext"

import type { ReactNode } from "react"

const SpinnerWrapper = ({ children }: { children: ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false)
  const loadingObj = useMemo(() => ({ isLoading, setIsLoading }), [isLoading])

  return (
    <LoadingContext.Provider value={loadingObj}>
      <Spinner isOpen={isLoading} />
      {children}
    </LoadingContext.Provider>
  )
}

export default SpinnerWrapper
